import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const PDFIcon = React.forwardRef((props, ref) => (
  <SvgIcon {...props} ref={ref}>
    <path d="m4 2v20h16v-14l-6-6zm9 1.5 5.5 5.5h-5.5zm-8 8.5h3c0.554 0 1 0.446 1 1v2c0 0.554-0.446 1-1 1h-2v2h-1zm5 0h3c0.554 0 1 0.446 1 1v4c0 0.554-0.446 1-1 1h-3zm5 0h4v1h-3v2h2.5v1h-2.5v2h-1zm-9 1v2h2v-2zm5 0v4h2v-4z" />
  </SvgIcon>
));

export default PDFIcon;
